import { render } from "./SponsorListPage.vue?vue&type=template&id=51f9fd9a"
import script from "./SponsorListPage.vue?vue&type=script&lang=js"
export * from "./SponsorListPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__